'use client'

import { clsx } from 'clsx'
import { Lock } from 'lucide-react'

interface FilterChipsProps {
  options: string[]
  selected: string
  onChange: (value: string) => void
  className?: string
  /** Options to mark with a small lock — readable, not writable (forum 055). */
  locked?: string[]
}

/**
 * Redesign filter row. Selected = black outline + bold ink; unselected = soft
 * border + muted. Gold is deliberately NOT used here — it stays reserved for the
 * screen's one signature action.
 */
export function FilterChips({ options, selected, onChange, className, locked }: FilterChipsProps) {
  return (
    <div className={clsx('flex gap-2 overflow-x-auto py-1.5', className)}>
      {options.map((option) => {
        const isActive = selected === option
        const isLocked = locked?.includes(option) ?? false
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={clsx(
              'px-3.5 py-1.5 rounded-full text-[13px] whitespace-nowrap flex-shrink-0 border bg-white transition-colors focus:outline-none focus:ring-2 focus:ring-border-hover',
              isActive
                ? 'border-brand-dark text-text-primary font-bold'
                : 'border-border-default text-text-muted font-semibold hover:text-text-primary hover:border-border-hover'
            )}
          >
            {isLocked && <Lock className="w-3 h-3 inline-block mr-1 -mt-0.5 opacity-70" aria-hidden />}
            {option}
            {isLocked && <span className="sr-only"> (replies only)</span>}
          </button>
        )
      })}
    </div>
  )
}
